import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAllPlacesList = async (): Promise<IGetPlacesList[]> => {
  return axiosDefaultApi.get(`/api/Places/GetPlacesForDropDownMenu`);
};

type QueryFnType = typeof getAllPlacesList;

type UseGetAllPlacesListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllPlacesList = ({ config }: UseGetAllPlacesListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllPlacesList'],
    queryFn: () => getAllPlacesList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των Τοποθεσιών.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};